import { defineMessages } from 'react-intl';

import { ActionNames } from './ApplicationMenu';

export const itemMessages = defineMessages({
  [ActionNames.ADD_TO_PANELLINKS]: {
    id: 'core.appMenu.addToPanelLinks',
    defaultMessage: 'Add to panel links',
  },
  [ActionNames.OPEN]: {
    id: 'core.appMenu.openNewTab',
    defaultMessage: 'Open in new tab',
  },
  [ActionNames.ACTIVATE]: {
    id: 'core.appMenu.activateTab',
    defaultMessage: 'Switch to tab',
  },
  [ActionNames.OPEN_DEFAULT]: {
    id: 'core.appMenu.openWithDefaults',
    defaultMessage: 'Open in new tab with defaults',
  },
});

export const toggleButtonMessages = defineMessages({
  openAppMenu: {
    id: 'core.appMenu.open',
    defaultMessage: 'Open ({hotkey})',
  },
  closeAppMenu: {
    id: 'core.appMenu.close',
    defaultMessage: 'Close ({hotkey})',
  },
});

export const searchBarMessages = defineMessages({
  search: {
    id: 'core.appMenu.search',
    defaultMessage: 'Search',
  },
});
